import { useFragment } from "@/gql/fragment-masking"

export { useFragment as getFragmentData }
